export default "* Musikinstrument\n* Tromme\n* Rytme\n";